import React from 'react';
import { motion } from 'framer-motion';
import { X, Plus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useManuals } from '../../contexts/ManualsContext';

export const AddManualModal = () => {
    const { darkMode } = useTheme();
    const { userRole } = useAuth();
    const {
        isAddingManual, setIsAddingManual,
        newManualTitle, setNewManualTitle,
        newManualCategory, setNewManualCategory,
        categories,
        addManual
    } = useManuals();

    if (!isAddingManual || userRole !== 'admin') return null;

    const handleAdd = () => {
        if (!newManualTitle.trim()) {
            alert('Введите название руководства');
            return;
        }
        addManual(newManualCategory, newManualTitle);
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={() => setIsAddingManual(false)}
        >
            <div
                className={`rounded-xl shadow-2xl w-full max-w-md p-6 ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                }`}
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>Новое руководство</h2>
                    <button
                        onClick={() => setIsAddingManual(false)}
                        className={`${darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>
                <div className="space-y-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Название</label>
                        <input
                            type="text"
                            value={newManualTitle}
                            onChange={(e) => setNewManualTitle(e.target.value)}
                            className={`w-full px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                                darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border border-gray-300'
                            }`}
                            placeholder="Введите название руководства"
                            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                        />
                    </div>
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Раздел</label>
                        <select
                            value={newManualCategory}
                            onChange={(e) => setNewManualCategory(e.target.value)}
                            className={`w-full px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                                darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border border-gray-300'
                            }`}
                        >
                            {categories.filter(c => c.id !== 'reports').map(category => (
                                <option key={category.id} value={category.id}>{category.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="flex justify-end space-x-3 pt-2">
                        <button
                            onClick={() => setIsAddingManual(false)}
                            className={`px-4 py-2 rounded-lg transition-colors ${
                                darkMode ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            Отмена
                        </button>
                        <button
                            onClick={handleAdd}
                            className={`px-4 py-2 rounded-lg transition-colors flex items-center ${
                                darkMode ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white'
                            }`}
                        >
                            <Plus className="w-4 h-4 mr-2" />
                            Создать
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};